import initSwiper from '../utils/swiper';

const about = {
	init() {
		this.teamSwipers();
		this.articlesSwiper();
		this.instagramSwiper();
		this.storyToggle();
	},

	teamSwipers() {
		this.initProfileSwiper('.__owl_team.__about');
		this.initProfileSwiper('.__owl_guides.__about');
	},

	initProfileSwiper(selector) {
		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: true,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 24,
			navigation: true,
			autoplay: true,
			autoplayDelay: 4000,
			speed: 800,
			breakpoints: {
				0: {slidesPerView: 1.15, spaceBetween: 18},
				768: {slidesPerView: 2.1, spaceBetween: 24},
				1200: {slidesPerView: 4, spaceBetween: 24},
			},
		});
	},

	instagramSwiper() {
		const selector = '.__feeds_swiper';

		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: false,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 20,
			navigation: false,
			autoplay: false,
			breakpoints: {
				0: {slidesPerView: 1.12, spaceBetween: 14},
				576: {slidesPerView: 2, spaceBetween: 16},
				992: {slidesPerView: 3, spaceBetween: 20},
				1200: {slidesPerView: 4, spaceBetween: 24},
			},
		});
	},

	articlesSwiper() {
		const selector = '.__about_articles_swiper';

		if (!document.querySelector(selector)) {
			return;
		}

		initSwiper(selector, {
			loop: false,
			centeredSlides: false,
			slideToClickedSlide: false,
			spaceBetween: 18,
			navigation: false,
			autoplay: false,
			breakpoints: {
				0: {slidesPerView: 1.08, spaceBetween: 14},
				576: {slidesPerView: 1.7, spaceBetween: 18},
				992: {slidesPerView: 2.5, spaceBetween: 22},
				1280: {slidesPerView: 3.2, spaceBetween: 24},
			},
		});
	},

	storyToggle() {
		const button = document.querySelector('.__about_story_toggle');
		const panel = document.querySelector('.__story_full');

		if (!button || !panel) {
			return;
		}

		button.addEventListener('click', () => {
			const isOpen = button.getAttribute('aria-expanded') === 'true';
			const shouldOpen = !isOpen;
			button.setAttribute('aria-expanded', String(!isOpen));
			panel.setAttribute('aria-hidden', String(isOpen));
			panel.classList.toggle('_open', shouldOpen);
			button.querySelector('span').textContent = isOpen ? 'Read full story' : 'Close story';

			if (shouldOpen) {
				window.setTimeout(() => {
					panel.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				}, 260);
			}
		});
	},
};

export default about;
